export default __webpack_public_path__ + "static/top-logo-1f6ce980010247c748cd292406f3e046.jpg";